export default "__VITE_ASSET__XFqVrjIj__"